/**
 * 房源管理路由
 */
export default {
  path: '/finance',
  name: 'finance',
  redirect: '/finance/statistics',
  component: () => import('../views/finance/index.vue'),
  meta: {
    headerTitle: '财务',
    icon: 'ab-iconfont ab-icon-finance',
    auth: 1008
  },
  children: [
    {
      path: 'statistics',
      name: 'statistics',
      component: () => import('../views/finance/statistics/index.vue'),
      meta: {
        headerTitle: '统计图表',
        icon: 'statistics'
      }
    },
    {
      path: 'roomSell',
      name: 'roomSell',
      component: () => import('../views/finance/roomSell/index.vue'),
      meta: {
        headerTitle: '房间销售表',
        icon: 'room-sell'
      }
    },
    {
      path: 'inExDetail',
      name: 'inExDetail',
      component: () => import('../views/finance/inExDetail/index.vue'),
      meta: {
        headerTitle: '收支明细表',
        icon: 'room-sell'
      }
    },
    {
      path: 'inExSummary',
      name: 'inExSummary',
      component: () => import('../views/finance/inExSummary/index.vue'),
      meta: {
        headerTitle: '收支汇总表',
        icon: 'room-sell'
      }
    }
  ]
}
